<template>
    <div>
        <van-sticky offset-top="44">
            <van-cell title="查询日期范围" :value="date" @click="show = true" is-link />
        </van-sticky>
        <van-list v-for="(item, index) in list" :key="index" >
            <div class="card-cell" @click="handleClickItem(item)">
                <van-icon name="arrow" class="arrow-icon"/>
                <van-cell is-link>
                    <template #title>
                        <span style="font-size: 15px;font-weight: 500;">单号-{{ item.pickNumber }}</span>
                    </template>
                    <template #right-icon>
                        <van-tag style="margin-left: 5px;" type="success" plain  size="medium">已完成</van-tag>
                    </template>
                </van-cell>
                <van-row type="flex" gutter="6">
                    <van-col span="24">
                        <van-cell class="inner-cell" title="物料名称：" :value="item.matName" />
                    </van-col>
                </van-row>
                <van-row type="flex" gutter="6">
                    <van-col span="12">
                        <van-cell class="inner-cell" title="拣货工：" :value="item.pickName" />
                    </van-col>
                    <van-col span="12">
                        <van-cell class="inner-cell" title="创建日期：" :value="item.createTime|formatDate('yyyy/MM/dd')" />
                    </van-col>
                </van-row>
                <van-row type="flex" gutter="6">
                    <van-col span="24">
                        <van-cell class="inner-cell" title="车型：" :value="item.vehicleModel" />
                    </van-col>
                </van-row>
                <van-row type="flex" gutter="6">
                    <van-col span="24">
                        <van-cell class="inner-cell" title="车牌号：" :value="item.numberPlate" />
                    </van-col>
                </van-row>
                <van-row type="flex" gutter="6">
                    <van-col span="10">
                        <van-cell class="inner-cell" title="姓名：" :value="item.driver" />
                    </van-col>
                    <van-col span="14">
                        <van-cell class="inner-cell" :title-style="{ width: '50px' }" title="电话：" :value="item.phoneNumber" />
                    </van-col>
                </van-row>
                <van-row type="flex" gutter="6">
                    <van-col span="24">
                        <van-cell class="inner-cell" title="拣货开始：" :value="item.startTime|formatDate('yyyy/MM/dd HH:mm')" />
                    </van-col>
                </van-row>
                <van-row type="flex" gutter="6">
                    <van-col span="24">
                        <van-cell class="inner-cell" title="拣货结束：" :value="item.finishTime|formatDate('yyyy/MM/dd HH:mm')" />

                    </van-col>
                </van-row>
                <van-row type="flex" gutter="6">
                    <van-col span="24">
                        <van-cell class="inner-cell" title="拣货耗时：" :value="item.timeConsuming" />
                    </van-col>
                </van-row>
                <van-row type="flex" gutter="6">
                    <van-col span="24">
                        <van-cell class="inner-cell" title="装货地：" :value="item.loadingRoute" />
                    </van-col>
                </van-row>    
                <van-row type="flex" gutter="6">
                    <van-col span="24">
                        <van-cell class="inner-cell" title=" 承运公司：" :value="item.shipperName" />
                    </van-col>
                </van-row>
                <van-row type="flex" gutter="6">
                    <van-col span="24">
                        <van-cell class="inner-cell" title="收货地：" :value="item.unloadingRoute" />
                    </van-col>
                </van-row>
            </div>
        </van-list>
        <van-pagination v-show="!!list.length" v-model="page.pageNo" :total-items="page.totalCount" :items-per-page="page.pageSize" @change="change" />
        <van-empty v-show="!list.length" description="数据为空"></van-empty>
        <van-calendar allow-same-day :min-date="minDate" :default-date="defaultDate" v-model="show" type="range" @confirm="onConfirm" />
    </div>
</template>

<script>
import { Search, List, Cell,Row,Col,Icon,Tag,Calendar,Empty,Pagination,Sticky} from 'vant';
import dayjs from 'dayjs';
export default {
    components: {
        [Search.name]: Search,
        [List.name]: List,
        [Cell.name]: Cell,
        [Row.name]: Row,
        [Col.name]: Col,
        [Icon.name]: Icon,
        [Tag.name]: Tag,
        [Calendar.name]: Calendar,
        [Empty.name]: Empty,
        [Pagination.name]: Pagination,
        [Sticky.name]: Sticky,
    },
    props: {
        activeName: {
            type: [String, Number],
            default: ''
        }
    },
    data() {
        return {
            defaultDate: [dayjs().subtract(1,'day').toDate(),dayjs().toDate()],
            minDate: dayjs().subtract(12, 'month').toDate(),
            date: '',
            show: false,
            list: [],
            page:{
                total: 0,
                pageNo: 1,
                pageSize: 10,
                totalCount: 0
            },
            isApp: ''//区分是消息推送点入还是app打开

        };
    },
    created() {
        this.isApp = navigator.userAgent.indexOf('demeter/') != -1?'app':'';//是否在app中
    },
    methods: {
        loadData() {
            let params = {
                pagable:true,// 是否分页
                pageNo: this.page.pageNo,
                pageSize: this.page.pageSize,
                source: this.isApp,

            }
            if (this.date) {
                params.startTime = dayjs(this.date.split('-')[0]).format('YYYY/MM/DD');
                params.endTime = dayjs(this.date.split('-')[1]).format('YYYY/MM/DD');
            }
            params.status = this.activeName;
            this.axios.get('/report/monitor/pickList/queryPageList', { params }).then(json => {
                if (json.statusCode == '0') {
                    this.list = json.list || [];
                    this.page.totalCount = json.totalCount;
                }
            });
        },
        change(page) {
            this.page.pageNo = page;
            this.loadData();
        },
        handleClickItem(item) {
            window.localStorage.setItem('palletMonitorItem', JSON.stringify(item));
            // 处理点击事件，根据 activeName 跳转不同的页面
            this.$router.push({
                path: '/workbench-palletMonitor-detail',
                query: { pickNumber: item.pickNumber, activeName: this.activeName }
            });
        },
        onConfirm(date) {
            const [start, end] = date;
            this.show = false;
            this.date = `${dayjs(start).format('YYYY/MM/DD')} - ${dayjs(end).format('YYYY/MM/DD')}`;
            this.loadData();
        }
    },
    mounted() {
        const _that = this;
        this.date = `${dayjs(this.defaultDate[0]).format('YYYY/MM/DD')} - ${dayjs(this.defaultDate[1]).format('YYYY/MM/DD')}`;
        this.$util.setToken((res) => {
            setTimeout(() => {
                _that.loadData();
            }, 100);
        });
    }
};
</script>

<style scoped>
.card-cell {
    margin:5px 10px;
    padding: 5px;
    border:1px solid #efefef;
    border-radius: 8px;
    background-color: #fff;
    margin-bottom: 10px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    overflow: hidden;
    position: relative;
}
.card-cell .arrow-icon {
    position: absolute;
    top: 50%;
    right: 5px;
    transform: translateY(-50%);
    font-size: 24px;
    color: #ccc;
    z-index: 1;
}
.card-cell .inner-cell{
    padding:2px 0px;
}
.card-cell .inner-cell .van-cell__title{
    width:70px;
    flex: none;
    text-align: right;
}
.card-cell .inner-cell .van-cell__value{
    text-align: left;
    color:#787878
}

</style>